import Vue from 'vue'
import Vuex from 'vuex'

// 保存状态
Vue.use(Vuex);

const state = {
  // 公共头部
  showHeader: true,
  // 公共底部
  showBottom: true,
};

export default new Vuex.Store({
  state
})



// WEBPACK FOOTER //
// ./src/store/index.js